<script lang="ts" setup>
import { computed, type PropType } from 'vue';

import { type MarketModel } from '@exchange/libs/market/service/src';
import { type CurrencyModel } from '@exchange/libs/utils/currency/src';

import MarketHeaderDetails from './MarketHeaderDetails.vue';
import MarketHeaderMarketSelect from './MarketHeaderMarketSelect.vue';

const props = defineProps({
  currencies: { type: Object as PropType<Dictionary<CurrencyModel>> },
  defaultFiatCurrency: { type: String, required: true },
  isFutures: { type: Boolean, default: false },
  market: { type: Object as PropType<MarketModel>, required: false },
  marketsList: { type: Array as PropType<Array<MarketModel>>, required: false },
  showMarketList: { type: Boolean, default: false },
});
const emit = defineEmits<{
  (e: 'market-clicked', value: string): void;
}>();

const marketId = computed(() => props.market?.id);
const onMarketClicked = (id: string) => {
  emit('market-clicked', id);
};
</script>

<template>
  <ot-module-container
    class="market-header"
    :scroll-settings="{ overflowVisible: true }"
    :with-bottom-padding="true"
  >
    <template #main-content>
      <div class="market-header__content">
        <div class="market-header__market-select">
          <market-header-market-select
            v-if="marketId"
            :is-futures="isFutures"
            :market="market"
            :markets-list="marketsList"
            :show-market-list="showMarketList"
            @market-clicked="onMarketClicked"
          />
        </div>
        <market-header-details
          :market="market"
          :currencies="currencies"
          :default-fiat-currency="defaultFiatCurrency"
        />
      </div>
    </template>
  </ot-module-container>
</template>

<style lang="scss">
.market-header {
  padding: 0;
  color: rgb(var(--v-theme-text-primary));

  &__content {
    display: flex;
    max-width: min-content;
    height: 100%;
    align-items: center;
    gap: 14px;
  }

  &__market-select {
    flex-shrink: 0;
    border-radius: 20px;
    background-color: rgb(var(--v-theme-elevation-2));
  }
}
</style>
